import { useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import { initAnalytics, trackPageView } from "./gaClient"

export default function RouteAnalytics() {
  const { pathname, search } = useLocation()
  const didInit = useRef(false)

  useEffect(() => {
    if (!didInit.current) {
      initAnalytics()
      didInit.current = true
    }
  }, [])

  useEffect(() => {
    trackPageView(pathname + search, document.title)
  }, [pathname, search])

  return null
}
